import React, { useState } from 'react';
import { Button } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { TemplateForm } from '../form';
import { Can } from 'src/utils/can';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';

export const CreateTemplateButton = () => {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState<boolean>(false);

  return (
    <Can I={Actions.Write} a={Subjects.Templates} appArea={AppArea.Wttp}>
      <Button
        variant="contained"
        className="place-self-end absolute top-1 right-0"
        onClick={() => setShowForm(true)}
      >
        {t('wttp.template.list.button-create-label')}
      </Button>
      {showForm && (
        <TemplateForm
          onFinish={() => setShowForm(false)}
          title={t('wttp.template.form.create-template')}
        />
      )}
    </Can>
  );
};
